// Graphite & Blue - aligned with the editor's "Godot Dark" theme
// (editor/src/themes/godotDark.ts) so the dashboard and editor read as one product.
export const theme = {
  bgApp: '#1c1c1c',
  bgPanel: '#242424',
  bgInput: '#1a1a1a',
  bgSurface: '#303030',
  bgSurfaceHover: '#3a3a3a',

  textPrimary: '#dddddd',
  textBright: '#eeeeee',
  textSecondary: '#aaaaaa',
  textMuted: '#787878',

  accent: '#4e9cde',
  accentHover: '#6bb0e8',
  accentText: '#ffffff',

  border: '#2f2f2f',
  borderStrong: '#3a3a3a',

  success: '#6abf69',
  successBg: '#16331a',
  warning: '#e69c4e',
  warningBg: '#3a2a12',
  error: '#e06c75',
  errorBg: '#3a1a1e',
  danger: '#b3434c',
  dangerHover: '#c65861',

  overlay: 'rgba(0, 0, 0, 0.7)',

  radiusSm: '4px',
  radiusMd: '6px',
  radiusLg: '8px',
};
